import api from './api';

export const authService = {
  login: (email, password) => api.post('/auth/login', { email, password }),
  getMe: () => api.get('/auth/me'),
  changePassword: (current_password, new_password) => api.post('/auth/change-password', {
    current_password,
    new_password
  })
};
